import { Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

interface UsersToolBarProps {
    setShowUserCard: (userId: number | false) => void;
}

const UsersToolBar = ({ setShowUserCard }: UsersToolBarProps) => {
    const { t } = useTranslation();

    return (
        <div className="mb-3" style={{ minWidth: '100px' }}>
            <div className="page-toolbar-actions">
                <Button className="fs-14 px-2 ms-1" size="sm" variant="success" onClick={() => setShowUserCard(-1)}>
                    <i className="bi bi-plus fs-14 p-0"></i>
                    <span className="d-none d-md-inline ms-1">{t('Users.toolBarAdd')}</span>
                </Button>
            </div>
        </div>
    );
};

export default UsersToolBar;
